import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '@shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { GetAddressDialogModule } from '@shared/components';
import { FormWidgetCompanyContactComponent } from '@bcm-work-flows/@form-widgets/company-contact/form-widget-company-contact.component';

@NgModule({
    declarations: [FormWidgetCompanyContactComponent],
    imports: [

        FuseSharedModule,
        SharedModule,

        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,

        GetAddressDialogModule
    ],
    exports: [FormWidgetCompanyContactComponent]
})
export class FormWidgetCompanyContactModule {
    
}
